import { useEffect, type FunctionComponent } from 'react';

export const PPOnboardingModalErrorHandler: FunctionComponent<{
  onComplete: () => void;
}> = ({ onComplete }) => {
  useEffect(() => {
    onComplete();
  }, [onComplete]);
  return null;
};
